// Owner documents shared by the owner filter, the bulk owner modals and every
// owners editor surface.
import { gql } from "graphql-tag";

// Owners that can be assigned to interests within the org (M2-T01 server query).
// Returns an UNORDERED set; the UI sorts/groups/pins "Me" client-side.
// `interestLists { id property { name } }` (the properties a staff member
// MANAGES) powers BOTH property-team grouping (HAV-55) AND the assign-owner-modal
// access-grant warning (HAV-56).
// HAV-188: do NOT request `interests` — Dataloader loads all ~200 Interest columns
// per staff user_id batch and times out, cascading 500s to reportQuery.
export const ASSIGNABLE_OWNERS = gql`
  query assignableOwners {
    assignableOwners {
      id
      profile {
        firstName
        lastName
        fullName
      }
      interestLists {
        id
        property {
          id
          name
        }
      }
    }
  }
`;

// Single-owner add/remove leave every other owner in place, so a removed owner
// also loses owner-scoped access.
export const ADD_INTEREST_OWNER = gql`
  mutation addInterestOwner($interestId: ID!, $userId: String!) {
    addInterestOwner(interestId: $interestId, userId: $userId)
  }
`;

export const REMOVE_INTEREST_OWNER = gql`
  mutation removeInterestOwner($interestId: ID!, $userId: String!) {
    removeInterestOwner(interestId: $interestId, userId: $userId)
  }
`;
